import {
    copyCurrentUrl,
    mail,
    share,
} from '../redux/share/actions'
import { social } from '../helpers/social'
import { isSocialDisplayed } from '../redux/print/selectors'

export const shareActions = [
    {
        name: 'copyUrl',
        action: copyCurrentUrl,
        icon: 'fa fa-link fa-2x',
        title: 'visualizer:toolbar.left.copyCurrentUrl.button',
        parameters : {
            message: 'visualizer:toolbar.left.copyCurrentUrl.confirm',
        }
    },
    {
        name: 'mail',
        action: mail,
        icon: 'fa fa-envelope fa-2x',
        title: 'visualizer:toolbar.left.shareMail.button',
    },
    {
        name: 'twitter',
        action: share,
        parameters: social.twitter,
        icon: 'nf nf-x-twitter nf-2x',
        title: 'visualizer:toolbar.left.twitter.button',
        isDisplayed: isSocialDisplayed,
    },
    {
        name: 'facebook',
        action: share,
        parameters: social.facebook,
        icon: 'nf nf-facebook-f nf-2x',
        title: 'visualizer:toolbar.left.facebook.button',
        isDisplayed: isSocialDisplayed,
    },
    {
        name: 'linkedin',
        action: share,
        parameters: social.linkedin,
        icon: 'nf nf-linkedin-in nf-2x',
        title: 'visualizer:toolbar.left.linkedin.button',
        isDisplayed: isSocialDisplayed,
    },
]
